<template>
  <div class="jbs-card">
<slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

.jbs-card{
  background-color: white;
  border: 1px solid #DFE0EB;
  border-radius: 10px;
  margin: 5px;
  padding: 10px;
}

</style>